export const getQueryParams = (window: WindowProxy): array =>
    window
    .location
    .search
    .slice(1)
    .split(`&`)
    .map(str => str.split(`=`));

export const mergeQueryParams = (queries: object): string =>
    queries
    .map(([key, value]) => `${key}=${value}`)
    .join(`&`);

// if (filter == true) returns only those with the same key
//else removes the key from list
const alterQueryParams = (filter: Boolean) => (queries: object, keys: string | array): array => {
    const allKeys = (keys instanceof Array) ? keys : [keys];
    let copy = Array.from(queries);
    return copy.filter(([key]) => filter ? allKeys.includes(key) : !allKeys.includes(key));
}

export const removeQueryParams = alterQueryParams(false);

export const filterQueryParams = alterQueryParams(true);